import RowLoader from 'components/Sceletons/RowLoader';
import React from 'react';
import classes from './PermissionsByFolder.module.scss';
import { Collapse, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { IGroup } from 'interfaces';
import { defaultGroups } from 'store/reducers/usersGroupCreator';
import { allPermissions } from 'helpers/createPermissionTableData';
import downloadCascadePermissionCases from 'components/PermissionsByFolder/cascadePermissionsRules/canDownload';
import classNames from 'classnames';

type PermissionsByFolderProps = {
  isLoading: boolean;
  permissionsOfFolder: IGroup[];
  setPermissionsOfFolder: React.Dispatch<React.SetStateAction<IGroup[]>>;
  parent: string;
}

const PermissionsByFolder = ({
  isLoading,
  permissionsOfFolder,
  setPermissionsOfFolder,
  parent,
}: PermissionsByFolderProps) => {
  
  const { t } = useTranslation();
  const parentClass = parent === 'newFolder' ? classes.newFolder : classes.configureFolder;
  const defaultOpenFolder = permissionsOfFolder.find(folder => folder.first_name === 'full_administrator')?.key;

  const onChangeRolePermisssions = (checked: boolean, _: any, group_id: string, permission: string) => {
    setPermissionsOfFolder(prev => prev.map(group => {
      const newPermissions = checked
        ? [...group.permissions || [], permission]
        : group.permissions?.filter(current => current !== permission) || []
    
      const isCanView = newPermissions.length !== 0;
      const isCanDownload = downloadCascadePermissionCases
        .map((permissions) => permissions.every((el) => newPermissions.includes(el)))
        .includes(true);
      isCanView && newPermissions.push('can_view');
      isCanDownload && newPermissions.push('can_download');
      Boolean(newPermissions.includes('can_download') || isCanDownload)
        && newPermissions.push('can_download_pdf');

      const unicPermissions = (Array.from(new Set(newPermissions)));

      return group.group_id === group_id
        ? {...group, permissions: unicPermissions}
        : group
    }));
  };  

  return (
    <div className={classNames(classes.configureContent, parentClass)}>
      {
        isLoading
          ? [1, 2, 3].map((_, i) => (<div key={`loader-${i}`}>
            <RowLoader width={'100%'} height={30} padding={'5px 0 0 0'} />
          </div>))
          : permissionsOfFolder?.map((role: any) => (
            <Collapse
              key={role.group_id}
              expandIconPlacement={'end'}
              bordered={false}
              className={classes.collapseElem}
              size='small'
              defaultActiveKey={[String(defaultOpenFolder)]}
              items={[{
              key: role.group_id,
              label: defaultGroups.includes(role.group_name) ? t(`Users.table.${role.group_name}`) : role.group_name,
              extra: `${role?.permissions?.length || 0}/${allPermissions?.length}`,
              children: allPermissions?.map((permission) => (
                  <div key={permission} className={classes.permissionItem}>
                    <span className={classes.permissionTitle}>{t(`Logs.logsModal.${permission}`)}</span>
                    <Switch
                      size='small'
                      disabled={role.first_name === 'full_administrator'}
                      checked={role?.permissions?.includes(permission)}
                      onChange={(checked, event) => onChangeRolePermisssions(checked, event, role.group_id, permission)}
                    />
                  </div>
                )),
              }]}
            />
          ))
      }
    </div>
  );
}

export default PermissionsByFolder;
